import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Button, Theme, SxProps, Tooltip } from '@mui/material';

const QUESTION_STRINGS = appStrings.modules.solutionSessions.questions;

type SkipButtonProps = Readonly<{
  isRequired: boolean;
  sendQAMessage: (message: string, LLMInput?: string) => void;
}>;

export const SkipButton = ({ isRequired, sendQAMessage }: SkipButtonProps) => {
  const handleSkip = () => {
    sendQAMessage('', QUESTION_STRINGS.skipThisQuestion);
  };

  const skipButton = (
    <Button
      id="solution-session-skip-button"
      hierarchy="Tertiary color"
      size="sm"
      onClick={isRequired ? undefined : handleSkip}
      disabled={isRequired}
      sx={buttonSx}
    >
      {QUESTION_STRINGS.skip}
    </Button>
  );

  return isRequired ? (
    <Tooltip title={QUESTION_STRINGS.skipTooltip} placement="bottom-end" arrow>
      {skipButton}
    </Tooltip>
  ) : (
    skipButton
  );
};

const buttonSx: SxProps<Theme> = ({ typography }) => ({
  ...typography['text-sm-semibold'],
});
